export default {
    getUid: state => state.uid,
    getSessionId: state => state.sessionId,
    getErrorState: state => state.errorState,
    getIsAuth: state => state.isAuth,
    getMenus: state => state.menus,
    getMyPages: state => state.myPages,
    getLocale: state => state.locale,
    getParams: state => state.params,
    getPopupParams: state => state.popupParams,
    getRegParams: state => state.regParams,
    getToken: state => state.token,
    getCorpCd: state => state.corpCd,
    getRoles: state => state.roles,
    getDeptNo: state => state.deptNo,
    getDeptLevelCd: state => state.deptLevelCd,
    getLoginNo: state => state.loginNo,
    getLoginRhq: state => state.loginRhq,
    getLoginSystem: state => state.loginSystem,
    getSuperUserYn: state => state.superUserYn,
    getSupportSnb: state => state.supportSnb,
    getSupportSnbParams: state => state.supportSnbParams,
    getConnSystem: state => state.connSystem,
    getReturnSystem: state => state.returnSystem,
    getLoginId: state => state.loginId,
    getCountryCd: state => state.countryCd,
    getCountryNm: state => state.countryNm,
    getCorpNo: state => state.corpNo,
    getCorpNm: state => state.corpNm,
    getCompanyNo: state => state.companyNo,
    getJoinDate: state => state.joinDate,
    getLastLogin: state => state.lastLogin,
    getLangCd: state => state.langCd,
    getGuid: state => state.guid,
    getEmail: state => state.email,
    getLoginCountryCd: state => state.loginCountryCd,
};



// WEBPACK FOOTER //
// ./src/vuex/getters.js